export default __webpack_public_path__ + "static/media/Meritorious_service.b94a9144.jpg";